import http from '@/plugs/httpServer';
import { serverName } from '@wj/common'
let feather_campus = "feather-campus"

// 忘记密码提交
export function forgetPWDsubmit(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/auth/resetPwd`,
		data: data,
	})
}


